import { ReactNode, useReducer } from "react";

// eslint-disable-next-line import/no-named-as-default
import produce from "immer";

import ProjectWrapper from "../components/ProjectWrapper";
import { ProjectContextState } from "./ProjectContextState";
import {
  Action,
  ProjectContext,
  ProjectDispatchContext,
  ProjectUpdates,
  initialProjectContextState
} from "./projectContexts";

// The context objects themselves live in ./projectContexts, a leaf module -
// this file adds the provider, whose ProjectWrapper import drags in a large
// slice of the app. Re-exported so existing imports keep working.
export * from "./projectContexts";

function ProjectReducer(
  state: ProjectContextState,
  action: Action<ProjectUpdates, "update">
) {
  return produce(state, (draft) => {
    Object.assign(draft, action.payload);
  });
}

export interface ProjectProviderModel {
  children: ReactNode;
  state?: ProjectContextState;
  useWrapper?: boolean;
}

export function ProjectProvider({
  children,
  state: overrideState,
  useWrapper
}: ProjectProviderModel) {
  const [state, dispatch] = useReducer(
    ProjectReducer,
    overrideState ?? initialProjectContextState
  );

  if (useWrapper === false) {
    return (
      <ProjectContext.Provider value={state}>
        <ProjectDispatchContext.Provider value={dispatch}>
          {children}
        </ProjectDispatchContext.Provider>
      </ProjectContext.Provider>
    );
  }

  return (
    <ProjectContext.Provider value={state}>
      <ProjectDispatchContext.Provider value={dispatch}>
        <ProjectWrapper>{children}</ProjectWrapper>
      </ProjectDispatchContext.Provider>
    </ProjectContext.Provider>
  );
}
